export function readPath(source, path) {
  if (!source || !path) return undefined;
  return path.split(".").reduce((acc, key) => {
    if (acc === null || acc === undefined) return undefined;
    return acc[key];
  }, source);
}

export function pickValue(source, paths) {
  for (const path of paths) {
    const value = readPath(source, path);
    if (value !== null && value !== undefined && value !== "") {
      return value;
    }
  }
  return undefined;
}

export function normalizeRecord(record) {
  if (!record || typeof record !== "object") return record;
  return record.user || record.data || record.result || record;
}

export function formatCellValue(value) {
  if (value === null || value === undefined || value === "") return "-";
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
}

function collectScalarEntries(source, prefix = "", acc = []) {
  if (!source || typeof source !== "object") return acc;

  Object.entries(source).forEach(([key, value]) => {
    const path = prefix ? `${prefix}.${key}` : key;
    if (value === null || value === undefined) return;
    if (typeof value === "object" && !Array.isArray(value)) {
      collectScalarEntries(value, path, acc);
      return;
    }
    if (typeof value !== "object") {
      acc.push({ path, key, value });
    }
  });

  return acc;
}

export function pickByKeyPattern(source, pattern, options = {}) {
  const { excludePatterns = [] } = options;
  const entries = collectScalarEntries(source);
  const match = entries.find(({ path, key }) => {
    const composite = `${path} ${key}`;
    if (!pattern.test(composite)) return false;
    return !excludePatterns.some((excludePattern) =>
      excludePattern.test(composite)
    );
  });
  return match?.value;
}
